/*
 * @author: liuchang
 * @description: 全局变量
 * @Description {type}
 */
// 版本号
// global.version = 'v3.2.0.128';
// 测试环境
global.exam_entry = 'https://examtest.devcorp.cn';
// 生产环境
// global.exam_entry = 'https://onlinetest.devcorp.cn';
global.loading = {
    returnBtn: false, // 退回
    select: false, // 查询
    confirm: false, // 确定
    add: false, // 添加
    save: false, // 保存
    submit: false // 提交
};
// 回归测试的流转状态
global.testCaseCode = {
    toBeTested: '03009000', // 待测试
    underTest: '03009001', // 测试中
    testComplete: '03009006' // 测试完成
};
// 成员状态
global.memberStatus = {
    beDemobilized: '00002001' // 离岗
};
// 任务状态
global.taskType = {
    commonTasks: '04000000', // 普通任务
    testCaseExecution: '04000001' // 测试用例执行
};
// bug优先级
global.bugPriority = {
    urgent: '00008000', // 紧急
    important: '00008001', // 重要
    commonly: '00008002', // 一般
    lower: '00008003' // 较低
};
// bug类型
global.bugType = {
    production: '00009000', // 生产问题
    test: '00009001', // 测试问题
    optimization: '00009002' // 需求优化
};
// 任务优先级
global.taskPriority = {
    urgentAndImportant: '04002000', // 紧急重要
    urgentIsNotImportant: '04002001', // 紧急不重要
    importantButNotUrgent: '04002002', // 重要不紧急
    notImportantNotUrgent: '04002003' // 不重要不紧急
};
// bug状态
global.bugStatus = {
    newlyBuild: '00007000', // 新建
    open: '00007001', // 打开
    reopen: '00007002', // 重新打开
    fixed: '00007003', // 已修复
    reject: '00007004', // 已拒绝
    closed: '00007005', // 关闭
    deferrd: '00007006' // 延期
};
// 测试用例状态
global.testCaseStatus = {
    fail: '03009003' // 不通过
};
// 测试用例状态
global.testCaseStatusPass = {
    fail: '03009002' // 通过
};
// 链接类型
global.linkType = {
    task: '00006003' // 任务
};
/**
 * @description:任务类型
 * @return {*}
 */
global.taskTypeShow = [
    { label: '普通任务', value: '04000000' },
    { label: '测试用例执行', value: '04000001' },
    { label: '缺陷登记', value: '04000002' },
    { label: '缺陷修复', value: '04000003' }
];

/**
 * @description:任务状态
 * @return {*}
 */
global.taskChangeStatus = {
    newAdd: '04001000', // 新建
    doing: '04001001', // 正在进行
    done: '04001002', // 完成
    suspend: '04001003', // 挂起
    abandon: '04001004'// 废弃
};
/**
 * @description:任务状态类型
 * @return {*}
 */
global.taskStatus = [
    { label: '新建', value: '04001000' },
    { label: ' 进行中', value: '04001001' },
    { label: '已完成', value: '04001002' },
    { label: '挂起', value: '04001003' },
    { label: '废弃', value: '04001004' }
];
/**
 * @description:任务优先级
 * @return {*}
 */
global.taskPriorityList = [
    { label: '紧急重要', value: '04002000' },
    { label: '紧急不重要', value: '04002001' },
    { label: '重要不紧急', value: '04002002' },
    { label: '不重要不紧急', value: '04002003' }
];
/**
 * @author: liuc
 * @description: 链接类型
 */
global.linkType = {
    devItem: '00006000', // 开发项
    testCase: '00006001', // 测试用例
    bug: '00006002', // 缺陷
    task: '00006003' // 任务
};
/**
 * @author: ct
 * @description: 离开项目类型
 */
global.leaveProjectType = {
    leave: '01000007',
    stop: '01000006'
};
/**
 * @description: UI测试用例类型
 * @return {*}
 */
global.uiTestCaseType = [
    {
        label: 'UI',
        value: '03008001'
    },
    {
        label: '接口',
        value: '03008000'
    },
    {
        label: '流程',
        value: '03008002'
    },
    {
        label: '压力',
        value: '03008003'
    }
];
// 默认角色code
global.defaultRoleList = ['R_01', 'R_02', 'R_03', 'R_04', 'R_05'];
// 默认选中项目组成员角色
global.defaultRoleCode = 'R_02';
// 回顾测试--当前轮次测试结果
global.testResult = [
    {
        label: '测试通过',
        value: true
    },
    {
        label: '测试不通过',
        value: false
    }
];



// WEBPACK FOOTER //
// ./src/utils/global.js